import actions from '@/core/store/adesao/itens-adesao/estorno/estornar/actions'
import mutations from '@/core/store/adesao/itens-adesao/estorno/estornar/mutations'
import state from '@/core/store/adesao/itens-adesao/estorno/estornar/state'

export default {
	state,
	actions,
	mutations,
}
